<template>
  <v-layout
    row
    wrap
    class="my-2">
    <v-flex
      xs1>
      {{ item.quantity }} x
    </v-flex>

    <v-flex
      xs1
      class="py-0">
      <v-avatar>
        <v-img :src="$helpers.imageFrom(item, 'tiny')"/>
      </v-avatar>
    </v-flex>

    <v-flex
      class="py-0"
      xs9>
      <v-layout
        row
        wrap>
        <v-flex xs9>
          <v-list-tile-title>
            <router-link
              :to="{
                name: 'single-product',
                params: { id: item.product_id }
              }"
              class="subheading"
            >
              {{ item.name }}
            </router-link>
          </v-list-tile-title>
          <v-list-tile-sub-title class="text-uppercase">
            <span>{{ $t('SKU:') }} {{ item.sku }}</span>
          </v-list-tile-sub-title>
          <line-item-components
            v-if="item.components && item.components.length"
            :components="item.components"
            linked
          />
          <line-item-extras
            v-if="item.extras && Object.values(item.extras).length"
            :extras="item.extras"
            class="mt-2"
          />
        </v-flex>
        <v-flex xs3>
          <item-tier-breakdown
            :item="item"
          />
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex xs1>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-chip
            small
            color="transparent"
            v-on="on"
          >
            {{ item.total | money }}
          </v-chip>
        </template>
        <span> {{ $t('{0} per item', [item.sale_price ? $options.filters.money(item.sale_price) : $options.filters.money(item.price)]) }}</span>
      </v-tooltip>

    </v-flex>
  </v-layout>
</template>

<script>
import LineItemExtras from '@/modules/Orders/components/Items/LineItemExtras'
import LineItemComponents from '@/modules/Orders/components/Items/LineItemComponents'
import ItemTierBreakdown from '@/modules/Orders/components/Items/ItemTierBreakdown'
import ItemTiersList from '@/modules/Orders/components/Items/ItemTiersList'

export default {
  name: 'LineItem',
  components: { ItemTiersList, ItemTierBreakdown, LineItemComponents, LineItemExtras },
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>
